/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import subHours from 'date-fns/sub_hours';
import format from 'date-fns/format';
import { callAPI } from 'lorautils/api';
import RichLabel from 'loracoms/RichLabel';
import Editable from 'loracoms/Editable';
import ShowIf from 'loracoms/ShowIf';
import AutoColor from 'loracoms/AutoColor';
import LineChart from 'loracoms/LineChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class DataPoints extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.datapoints');
    this.handleChangeDesc = this.handleChangeDesc.bind(this);
    this.handleSubmitDesc = this.handleSubmitDesc.bind(this);
  }

  componentWillMount() {
    const { appId } = this.props;
    callAPI({
      endpoint: '/lora/dps',
      query: {
        appid: appId,
      },
    }).then((data) => {
      this.setState({
        dataPoints: data.list,
        status: 'success',
      });
      callAPI({
        endpoint: '/lora/timeseries',
        method: 'POST',
        body: {
          appid: appId,
          dps: data.list.map(dp => dp.id),
          from: subHours(new Date(), 1),
          limit: 1000,
        },
      }).then((tsData) => {
        tsData.list.reverse();
        this.setState({
          timeSeries: tsData.list,
          categories: _.map(tsData.list, 'timestamp'),
        });
      }).catch(() => {});
    }).catch(() => {
      this.setState({ status: 'failure' });
    });
  }

  getSeries(id) {
    const { timeSeries = [] } = this.state;
    const data = timeSeries.map((item) => {
      if (!_.isNil(item.metrics[id])) {
        return item.metrics[id];
      }
      return '-';
    });
    return { data };
  }

  handleChangeDesc(data) {
    this.setState({ editDescData: data });
  }

  handleSubmitDesc() {
    const { appId } = this.props;
    const { editDesc: id, editDescData, dataPoints } = this.state;
    if (!_.isNil(id)) {
      callAPI({
        endpoint: '/lora/dps',
        body: {
          id,
          desc: editDescData[id],
          appid: appId,
        },
        method: 'PUT',
      }).then(() => {
        this.setState({
          dataPoints: dataPoints.map((dp) => {
            if (dp.id === id) {
              return { ...dp, desc: editDescData[id] };
            }
            return dp;
          }),
        });
      }).catch(() => {});
    }
    this.setState({ editDesc: '' });
  }

  render() {
    const { pushState, appId } = this.props;
    const {
      dataPoints = [],
      status = 'pending',
      editDesc = '',
      editDescData = {},
      categories = [],
    } = this.state;
    if (status === 'pending') {
      return (
        <div className={styles.loading}>
          <i className="fa fa-spinner fa-spin fa-3x" />
        </div>
      );
    }
    if (dataPoints.length === 0) {
      return (
        <div className="text-center">
          <div className={styles.noData}>
            {this.intlMsg.msg('nodps')}
          </div>
          <div className={styles.guide}>
            <p>
              {this.intlMsg.msg('how')}
            </p>
            <ol>
              <li>{this.intlMsg.msg('how.tx')}</li>
              <li>
                {this.intlMsg.msg('how.parse.prefix')}
                <Link onClick={() => pushState(`/application/${appId}/parse`)}>{this.intlMsg.msg('how.parse.parser')}</Link>
                {this.intlMsg.msg('how.parse.postfix')}
              </li>
              <li>{this.intlMsg.msg('how.dps')}</li>
            </ol>
          </div>
        </div>
      );
    }

    const dps = dataPoints.map((dp) => {
      const series = this.getSeries(dp.id);
      return (
        <div key={dp.id} className={`${styles.dp} ${styles[dp.type]}`}>
          <div className={styles.block}>
            <Link onClick={() => pushState(`/application/${appId}/dps/${dp.id}/trend`)}>
              <div className="text-center">
                <AutoColor className={styles.circle} content={dp.id}>
                  {dp.id[0]}
                </AutoColor>
              </div>
            </Link>
            <div className="text-center">
              <RichLabel content={dp.type} inverse />
            </div>
          </div>
          <div className={`${styles.block} ${styles.basic}`}>
            <div className={styles.id}>
              <Link onClick={() => pushState(`/application/${appId}/dps/${dp.id}/trend`)}>
                {dp.id}
              </Link>
              <Link
                className={styles.trendLink}
                onClick={() => pushState(`/application/${appId}/dps/${dp.id}/trend`)}
              >
                <i className="fa fa-line-chart" />
              </Link>
            </div>
            <div className={styles.desc}>
              <Editable
                id={dp.id}
                value={dp.desc}
                data={editDescData}
                edit={editDesc === dp.id}
                onChange={this.handleChangeDesc}
                formatter={(x) => {
                  if (x === '' || _.isNil(x)) {
                    return (
                      <Link
                        onClick={() => { this.setState({ editDesc: dp.id }); }}
                        className={styles.clickToEdit}
                      >
                        {this.intlMsg.msg('clicktoedit')}
                      </Link>
                    );
                  }
                  return <span>{x}</span>;
                }}
              />
              <ShowIf if={dp.desc !== '' && !_.isNil(dp.desc) && editDesc !== dp.id}>
                <Link
                  className={styles.edit}
                  onClick={() => this.setState({
                    editDesc: dp.id,
                    editDescData: { [dp.id]: dp.desc },
                  })}
                >
                  <span className="halflings halflings-pencil" />
                </Link>
              </ShowIf>
              <ShowIf if={editDesc === dp.id}>
                <span className={styles.submit}>
                  <Link
                    className={styles.ok}
                    onClick={this.handleSubmitDesc}
                  >
                    <span className="halflings halflings-ok" />
                  </Link>
                  <Link className={styles.cancel} onClick={() => this.setState({ editDesc: '' })}>
                    <span className="halflings halflings-remove" />
                  </Link>
                </span>
              </ShowIf>
            </div>
          </div>
          <div className={`${styles.block} ${styles.trend}`}>
            <LineChart
              series={[{
                ...series,
                areaStyle: {
                  normal: {
                    opacity: 0,
                  },
                },
                showAllSymbol: true,
              }]}
              categories={categories}
              height={74}
              xAxis={{ show: false }}
              yAxis={{ show: false }}
              grid={{
                left: 10,
                top: 10,
                right: 0,
                bottom: 20,
              }}
              tooltip={{
                formatter: params => `${format(params[0].name, 'YYYY-MM-DD HH:mm:ss')}<br/>${dp.id}: ${params[0].value}`,
              }}
            />
          </div>
        </div>
      );
    });

    return (
      <div className={styles.container}>
        {dps}
      </div>
    );
  }
}

const mapDispatchToProps = {
  pushState: routerActions.push,
};

DataPoints.propTypes = propTypes;

export default connect(null, mapDispatchToProps)(injectIntl(DataPoints));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPoints/index.jsx